import { useBlockDependencyVisibility } from '@shared/hooks/useBlockDependencyVisibility';
import { LayoutBuilderType, ServiceVM, TreeNode } from '@shared/types/process';

import { BlockView } from './BlockView';
import { BlockViewTab } from './BlockView/BlockViewTab';
import ChildLayout from './ChildLayout';

import { css } from '@emotion/css';

export const LayoutBloc = ({
    block,
    service,
    childrenBtnForFlowTab,
    flowTabType,
    isParent,
    isReadOnly,
    tabProps,
    classNameWrapper,
}: {
    block: TreeNode<LayoutBuilderType>;
    service?: ServiceVM;
    childrenBtnForFlowTab?: React.ReactNode;
    flowTabType?: React.ComponentPropsWithoutRef<
        typeof BlockViewTab
    >['flowTabType'];
    isParent?: boolean;
    isReadOnly?: boolean;
    tabProps?: React.ComponentPropsWithoutRef<typeof BlockViewTab>['tabProps'];
    classNameWrapper?: string;
}) => {
    const isHiddenBlocDependency = useBlockDependencyVisibility(block);

    if (isHiddenBlocDependency) {
        return null;
    }

    return (
        <div
            className={css`
                position: relative;
                height: fit-content;
                overflow-x: hidden;
            `}
        >
            <BlockView
                block={block}
                childrenBtnForFlowTab={childrenBtnForFlowTab}
                classNameWrapper={classNameWrapper}
                flowTabType={flowTabType}
                isParent={isParent}
                isReadOnly={isReadOnly}
                service={service}
                tabProps={tabProps}
                ChildrenContext={
                    <ChildLayout
                        childrenBlocks={block.children}
                        classNameWrapper={classNameWrapper}
                        flowTabType={flowTabType}
                        isReadOnly={isReadOnly}
                        service={service}
                        tabProps={tabProps}
                    />
                }
            />
        </div>
    );
};
